import { Toaster, toast } from "sonner";

export { toast };

/**
 * The single toast host for the application. Browser-native dialogs are
 * prohibited on the platform, so every mutation feedback routes through here
 * (README section 0.1.2, "toast-only feedback").
 */
export function ToastHost() {
  return (
    <Toaster
      position="top-right"
      richColors
      toastOptions={{
        style: {
          fontFamily: "inherit",
        },
      }}
    />
  );
}
